import {
  AUTH_LOGOUT_ERROR,
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_SUCCESS,
} from '~gatsby-theme-autonomy/redux/actions/types'

import { forgetCart } from '~gatsby-theme-autonomy/redux/actions/cart/forget-cart'

import auth from '~gatsby-theme-autonomy/services/auth'

export const logoutRequest = () => {
  return {
    type: AUTH_LOGOUT_REQUEST,
  }
}

export const logoutSuccess = (payload) => {
  return {
    type: AUTH_LOGOUT_SUCCESS,
    payload,
  }
}

export const logoutError = (error) => {
  return {
    type: AUTH_LOGOUT_ERROR,
    error: true,
    payload: {
      error,
    },
  }
}

export const logout = () => async (dispatch, getState) => {
  const email = getState().user.data?.email

  try {
    dispatch(logoutRequest())
    try {
      await auth.logout()
    } catch (e) {
      console.warn('logging out failed', e)
    }
    await dispatch(logoutSuccess({ email }))
    await dispatch(forgetCart())
  } catch (error) {
    dispatch(logoutError(error))
    throw error
  }
}
